import { defineAsyncComponent } from 'vue'

export const ModalShareGame = defineAsyncComponent(() => import('../ModalShareGame/ModalShareGame.vue'))
